import { useSelector } from 'react-redux'
import { useExportsList } from '../../lib/hooks'
import PageTitle from '../fragments/PageTitle'
import classes from './Exports.module.css'
// import Pagination from './pagination/Pagination'
import ExportsHeader from './ExportsHeader'
import ExportsRow from './ExportsRow'
import { exports_table_header_cells } from '../../assets/data'
import ExportsFilters from './ExportsFilters'
import MockRows from '../mock/MockRows'
import Pagination from '../work_queues/pages/pagination/Pagination'

export default function Exports() {

    // / get the referrals list from the hook 
    useExportsList()

    const loading = useSelector(state => state.exports.loading)
    const snapshot = useSelector(state => state.exports.snapshotData)
    const patientsList =  useSelector(state => state.exports.currentpagedata)

    console.log('exports list:::: ', patientsList)

    return <>
        <div className={`${classes.header_box} `}>
            <div>
                <div className='flex-container'>
                    <PageTitle isContainer={true}>
                        Exports    
                    </PageTitle>
                    <p className={classes.message}>
                        <i className="ti ti-info-circle" aria-hidden="true"></i>
                        <span>Exports are kept for 40 days. After that they are removed and cannot be downloaded.</span>
                    </p>
                    {/* {caseId && <Button btnStyle={'btn_dark'} click={viewAllHistory}>View all exports</Button>} */}
                </div>
            </div>
            
            {/* <ExportsFilters /> */}
        </div>

        <div className={``}>
            <div className={`${classes.content_wrapper}`}>
                <table>
                    <ExportsHeader/>
                    {loading && !snapshot && <tbody className={`${classes.table_body} ${classes.table_body_loading}`}>
                        <MockRows numberOfRows={exports_table_header_cells.length}/>
                    </tbody>}
                    {loading && snapshot && <tbody className={`${classes.table_body} ${classes.table_body_loading}`}>
                        {snapshot.data.map((item, index) => (
                            <ExportsRow key={item.id} data={item} index={index} classes={classes} />
                        ))}
                    </tbody>}
                    {!loading && patientsList && patientsList.data && <tbody>
                        {patientsList.data.map((item, index) => (
                            <ExportsRow key={item.id} data={item} index={index} classes={classes} />
                        ))}    
                    </tbody>}    
                    {!loading && !patientsList  && <tbody>
                        <tr>
                            <td colSpan={exports_table_header_cells.length}>No items found</td>    
                        </tr> 
                    </tbody>}        
                </table>                
            </div>

            {patientsList && patientsList.meta && <div className={`${classes.pagination_container}`}>
                {patientsList  && <Pagination data={patientsList} apiType='exports' hidePerPage={true} />}
            </div>}
        </div>
    </>
}